module.exports = __webpack_public_path__ + "img/P150T_weapon_53.867c3af6.png";